import dynamic from 'next/dynamic';
import { ReactElement } from 'react';

/*
 * 레이아웃별 컴포넌트를 정적 import 하면 모듈 로드 시점에 모든 레이아웃이 번들에 들어간다.
 * 예를 들어 뉴스 목록만 필요한 /about/news 가 갤러리 목록·상품 상세·글쓰기 폼까지 끌고 왔다.
 * next/dynamic 으로 라우트가 실제로 쓰는 레이아웃만 로드한다.
 * ssr 기본값(true)이라 초기 렌더 결과는 동일하다.
 */
const Custom404 = dynamic(() => import('@/pages/404'));
const GeneralBoardDetail = dynamic(
  () => import('@/components/apps/board/detail/view/GeneralBoardDetail'),
);
const ProductBoardDetail = dynamic(
  () => import('@/components/apps/board/detail/view/ProductBoardDetail'),
);
const GeneralContentForm = dynamic(
  () => import('@/components/apps/board/edit/GeneralContentForm'),
);
const GalleryBoardList = dynamic(
  () => import('@/components/apps/board/list/layout/GalleryBoardList'),
);
const GalleryModalBoardList = dynamic(
  () => import('@/components/apps/board/list/layout/GalleryModalBoardList'),
);
const GeneralBoardList = dynamic(
  () => import('@/components/apps/board/list/layout/GeneralBoardList'),
);
const NewsBoardList = dynamic(
  () => import('@/components/apps/board/list/layout/NewsBoardList'),
);

type BdComponentsType = {
  list: ReactElement;
  detail?: ReactElement;
  edit?: ReactElement;
};

export type BdOptionsType = {
  [key: string]: BdComponentsType;
};

export const bdOptions: BdOptionsType = {
  general: {
    list: <GeneralBoardList />,
    detail: <GeneralBoardDetail />,
    edit: <GeneralContentForm />,
  },
  gallery: {
    list: <GalleryBoardList />,
    detail: <GeneralBoardDetail />,
    edit: <GeneralContentForm />,
  },
  galleryModal: {
    list: <GalleryModalBoardList />,
    detail: <GeneralBoardDetail />,
    edit: <GeneralContentForm />,
  },
  'gallery-modal': {
    list: <GalleryModalBoardList />,
    detail: <GeneralBoardDetail />,
    edit: <GeneralContentForm />,
  },
  // 일반 게시판 레이아웃
  news: {
    list: <NewsBoardList />,
    detail: <GeneralBoardDetail />,
    edit: <GeneralContentForm />,
  },
  product: {
    list: <GalleryBoardList />,
    detail: <ProductBoardDetail />,
    edit: <GeneralContentForm />,
  },
};

export const getAppsBdOptions = (layout: string): BdComponentsType => {
  return (
    bdOptions[layout] || {
      list: <Custom404 />,
      detail: <Custom404 />,
      edit: <Custom404 />,
    }
  );
};
